var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var UserGroupController = {
    /*****************************************************************************************************
        * Is using route "api/userGroup/get/{groupid}/{take?}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {number | null} take
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<UserGroupDownloadDto, PagingTokenContainer>}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/get/{groupid}/{take?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/create/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {UserGroupUploadDto} dto
        * @returns {UserGroupDownloadDto}
    ******************************************************************************************************/
    Create: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/create/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/setGroupRoles/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {GroupRolesUploadDto[]} grs
        * @returns {UserGroupDownloadDto}
    ******************************************************************************************************/
    SetGroupRoles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("grs", JSON.stringify(data.grs));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/setGroupRoles/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/delete/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    Delete: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/delete/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/addUser/{id}/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    AddUser: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/addUser/{id}/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/removeUser/{id}/{userId}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    RemoveUser: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/removeUser/{id}/{userId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/userGroup/getUsers/{id}/{take?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {number | null} take
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<UserShortInfoDownloadDto, PagingTokenContainer>}
    ******************************************************************************************************/
    GetUsers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/userGroup/getUsers/{id}/{take?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=UserGroupController.js.map